"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDirective = exports.directive = void 0;
const directives = new WeakMap();
const directive = (f) => ((...args) => {
    const d = f(...args);
    directives.set(d, true);
    return d;
});
exports.directive = directive;
const isDirective = (o) => {
    return typeof o === 'function' && directives.has(o);
};
exports.isDirective = isDirective;
